import React from "react";
import { Outlet } from "react-router-dom";

const MinhasCopias: React.FC = () => {
  return <Outlet />;
};

export default MinhasCopias;
